import Marquee from "react-fast-marquee";
import { MARQUEE_ITEMS } from "@/lib/data";

export const MarqueeStrip = () => {
  return (
    <section
      className="py-6 border-y border-border bg-secondary/60 overflow-hidden"
      data-testid="marquee-strip"
    >
      <Marquee speed={40} gradient={false} autoFill>
        {MARQUEE_ITEMS.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display italic text-3xl sm:text-4xl text-foreground px-8">
              {item}
            </span>
            <span className="text-accent text-2xl">✳</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
};
